import React, { useEffect, useState } from 'react';
import { ChevronRight, CircleAlert } from 'lucide-react';

import { Alert, AlertDescription, AlertTitle } from 'shadcn/components/ui/Alert';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from 'shadcn/components/ui/Collapsible';
import { cn } from 'shadcn/lib/utils';

/**
 * @param {Object} props
 * @param {string} [props.className]
 * @param {string} props.description
 * @param {string} props.title
 */
function CollapsibleAlert({ className, description, title }) {
    const [isOpen, setIsOpen] = useState(true);

    useEffect(() => {
        setIsOpen(true);
    }, [description, title]);

    return (
        <Collapsible className={cn('mb-4', className)} open={isOpen} onOpenChange={setIsOpen}>
            <div className={cn(isOpen ? 'pt-0' : 'py-0.5')}>
                <CollapsibleTrigger asChild>
                    <button
                        type="button"
                        aria-label={`${title} alert`}
                        className="flex h-6 w-full items-center gap-1.5 rounded-sm text-left text-destructive transition-colors hover:bg-destructive/10"
                    >
                        <ChevronRight
                            aria-hidden="true"
                            className={cn(
                                'size-3.5 shrink-0 text-muted-foreground transition-transform duration-200',
                                isOpen && 'rotate-90',
                            )}
                        />
                        <CircleAlert aria-hidden="true" className="size-3.5 shrink-0" />
                        <span className="text-sm leading-none font-semibold">{title}</span>
                    </button>
                </CollapsibleTrigger>
            </div>
            <CollapsibleContent>
                <Alert variant="destructive">
                    <AlertTitle>{title}</AlertTitle>
                    <AlertDescription>{description}</AlertDescription>
                </Alert>
            </CollapsibleContent>
        </Collapsible>
    );
}

export { CollapsibleAlert };
